
import { reactive } from "vue";
import isMobile from "ismobilejs";

type setupType = {
  status: { hover: boolean };
  hoverHandler: (state: boolean) => void;
  touchHandler: (state: boolean) => void;
};

export default {
  name: "GitHub",
  props: {
    theme: String,
    url: String,
  },
  setup(): setupType {
    const status = reactive<{ hover: boolean }>({
      hover: false,
    });

    const hoverHandler = (state: boolean) => {
      if (isMobile().any) return;
      status.hover = state;
    };

    const touchHandler = (state: boolean) => {
      if (!isMobile().any) return;
      status.hover = state;
    };

    return {
      status,
      hoverHandler,
      touchHandler,
    };
  },
};
